import React from 'react';
import { PropTypes } from 'prop-types';
import { Spacer } from '@ontruck/orc';
import cx from 'classnames';
import ProgressBar from 'components/orders/ProgressBar';
import { useTranslation } from 'react-i18next';
import { CalendarIcon } from 'refactored/ui/icons';
import { useOrderStop } from 'components/orders/OrderStop/UseOrderStop';
import EditStopBtn from './components/EditStopBtn';

import AditionalOptions from 'components/summary/AditionalOptions';
import { selectors as orderSelectors } from 'state/order';
import { useSelector } from 'react-redux';
import LoadsSummaryTable from 'refactored/features/order/loads/displays/LoadsSummaryTable';

const OrderStop = ({
  className,
  forcePendingAppointment,
  shipmentKey,
  stopType,
}) => {
  const { t } = useTranslation('OrderStop');
  const { loads, addressFullData, stopName, getFullDate, appointmentDate } =
    useOrderStop();
  const isRecurring = useSelector((state) =>
    orderSelectors.getIsRecurringOrder(state)
  );
  const { t: tSummary } = useTranslation('Summary');
  return (
    <div className={cx(className, 'order-stop')}>
      <ProgressBar />
      <div className="order-stop__wrapper">
        <EditStopBtn />
        <div className="order-stop__date">
          {!appointmentDate && <span>{getFullDate()}</span>}
          {forcePendingAppointment && (
            <span className="pending_appointment">
              {t('pending_appointment')}
            </span>
          )}
          {appointmentDate && (
            <>
              <CalendarIcon />
              {` ${appointmentDate}`}
            </>
          )}
        </div>
        <h3 className="order-stop__name">{stopName}</h3>
        <div className="order-stop__address">{addressFullData}</div>
        <Spacer className="order-stop__load-info-wrapper" mTop="M">
          <LoadsSummaryTable loads={loads} />
        </Spacer>
        {shipmentKey && (
          <div className="summary-item">
            <AditionalOptions
              shipmentKey={shipmentKey}
              stopType={stopType}
              isRecurring={isRecurring}
              t={tSummary}
            />
          </div>
        )}
      </div>
    </div>
  );
};

OrderStop.propTypes = {
  className: PropTypes.string,
  forcePendingAppointment: PropTypes.bool,
};

OrderStop.defaultProps = {
  forcePendingAppointment: false,
};

export default OrderStop;
